import { useEffect, useState } from "react";
import { type SessionState, snapshot, state$ } from "./state";

export function useSession(): SessionState {
  const [value, setValue] = useState<SessionState>(snapshot);
  useEffect(() => {
    const sub = state$.subscribe(setValue);
    return () => sub.unsubscribe();
  }, []);
  return value;
}
